// src/components/Footer.js
import React, { useState } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import ContactModal from "../pages/ContactModal ";

function Footer() {
  const [showContactModal, setShowContactModal] = useState(false);
  // Modal Handlers
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);
  return (
    <footer className="footer text-center py-3 mt-5 text-white">
      <Container>
        <Row>
          <Col>
            <Nav className="justify-content-center">
              <Nav.Link as={Link} to="/" className="text-white">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="text-white">
                About Us
              </Nav.Link>
              <Nav.Link as={Link} to="/how-it-works" className="text-white">
                How It Works
              </Nav.Link>
              <Nav.Link
                as={Link}
                onClick={handleShowContactModal}
                className="text-white"
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="mt-3">&copy; 2024 E-Receipt. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
      <ContactModal
        show={showContactModal}
        handleClose={handleCloseContactModal}
      />
    </footer>
  );
}

export default Footer;
